import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasProgramLimitSchema = withDefaults({
  type: 'tas-program-limit',
  fields: [
    {
      kind: 'attribute',
      name: 'limitCoefficient',
    },
    {
      kind: 'attribute',
      name: 'employmentType',
    },
    {
      kind: 'belongsTo',
      name: 'limit',
      type: 'limit',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramTemplate',
      type: 'tas-program-template',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasGroup',
      type: 'tas-group',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tasApplications',
      type: 'tas-application',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tasAssistances',
      type: 'tas-assistance',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TasProgramLimitSchema;
